import React, { useMemo } from 'react';
import Lottie from 'react-lottie-player';

type LottieProps = {
  animationData: any;
  width?: number;
  height?: number;
  className?: string;
  loop?: number | boolean;
  segments?: [number, number];
};

export const LottieContainer = (props: LottieProps) => {
  const { segments, loop, height, className, width, animationData } = props;

  const style = useMemo(() => ({ width, height }), [width, height]);
  return (
    <div style={style} className={className}>
      <Lottie
        animationData={animationData}
        segments={segments}
        play={true}
        loop={loop}
      />
    </div>
  );
};
